export default class Navigation {
    initialize() {
        this.userDropdown();
        this.mobileNav();
    }

    userDropdown() {
        var dropdown_toggle = $('#user-dropdown-toggler');
        var dropdown_menu   = $('#user-dropdown-menu');

        dropdown_toggle.on('click tap', function(e) {
			e.preventDefault();
            dropdown_menu.toggleClass('show-dropdown');
        });

        // Close on click outside
        $(document).on("click", function(event){
            var $trigger = $(".user-dropdown");

            if($trigger !== event.target && !$trigger.has(event.target).length){
                dropdown_menu.removeClass('show-dropdown');
            }            
        });
    }

    mobileNav() {
		const mobileToggle = $('.mobile-menu-toggle');
		const mobileNav = $('.fullscreen-mobile-menu');

		mobileToggle.on('click', function () {
			toggleMobileNav($(this));
		});

		function toggleMobileNav(toggle) {
			var headerHeight = $('#site-header').outerHeight();
			const target = $('.fullscreen-mobile-menu');

			// Apply the right top spacing
			target.css('top', `${headerHeight}px`);
			
			// Only proceed with the rest of the changes once the height has been set to avoid weird animations.
			setTimeout(function() {
				// Toggle the open classes
				toggle.toggleClass('open');
				target.toggleClass('open');

				// If mobile or account navs are still open, don't allow scrolling
				if (!(mobileNav.hasClass('open')) && 'hidden' == $('body').css('overflow')) {
					$('body').css('overflow', 'auto');
				} else {
					$('body').css('overflow', 'hidden');
				}
			}, 150);
		}

		$( window ).resize(function() {
			// On resize, close the mobile menu
			if ((mobileNav.hasClass('open')) && 'hidden' == $('body').css('overflow')) {
				// Close all menus
				mobileNav.removeClass('open');

				// Remove all open indicators
				mobileToggle.removeClass('open');

				// Allow scrolling the body
				$('body').css('overflow', 'auto');
			}
		});
	}

} // end Navigation